/**
 * ルートが現在のクラブの機能フラグにより許可されるかを判定する。
 *
 * route.matched に meta.requiresHalls / meta.requiresFloor を持つ
 * いずれかがあり、currentClub の対応フラグが無効なら false を返す。
 *
 * @param {Object} route        Vue Router の to オブジェクト (matched 配列を持つ)
 * @param {Object} currentClub  { hallsEnabled, floorEnabled, ... }
 * @returns {boolean}
 */
export const isRouteAllowedByFeatureFlags = (route, currentClub) => {
  const matched = (route && route.matched) || []
  const requiresHalls = matched.some(r => r.meta && r.meta.requiresHalls)
  const requiresFloor = matched.some(r => r.meta && r.meta.requiresFloor)

  if (requiresHalls && currentClub && currentClub.hallsEnabled === false) return false
  if (requiresFloor && (!currentClub || currentClub.floorEnabled !== true)) return false

  return true
}

/**
 * ログイン後のホーム画面ルートを決定する
 */
export const getHomeRoute = (currentUser, currentClub) => {
  const userRole = currentUser && currentUser.role ? currentUser.role : null

  // 有効になっている機能を考慮してwaiterルートを決定
  const hallsEnabled = currentClub?.hallsEnabled !== false
  const floorEnabled = currentClub?.floorEnabled === true
  let waiterRoute
  if (hallsEnabled && floorEnabled) {
    waiterRoute = currentClub?.defaultTableView === 'floor' ? 'waiter-floor' : 'waiter-halls'
  } else if (floorEnabled) {
    waiterRoute = 'waiter-floor'
  } else {
    waiterRoute = 'waiter-halls'
  }

  const routeNames = {
    admin: 'admin-home',
    waiter: waiterRoute,
    cast: 'cast-test',
    custom: waiterRoute,
  }
  const routeName = routeNames[userRole]

  if (!routeName || !currentClub?.slug) return { name: 'auth-login' }

  return { name: routeName, params: { club_slug: currentClub.slug } }
}
